export default "__VITE_ASSET__DsWcRE1J__"